const articles = {
  init(){
    this.filters.changeItems();
    this.modalWindow();
    this.btnTrash.init();
  },
  filters: {
    changeItems(){
      const filters = document.querySelectorAll('[data-filter-container]');
      if(filters.length){
        filters.forEach(filter => {
          const trigger = filter.querySelector('[data-filter-trigger]');
          const content = filter.querySelector('[data-filter-content]');
          const items = content.querySelectorAll('.filter-item');

          trigger.addEventListener('click', ()=>{
            filters.forEach( filter => {
              if(filter.querySelector('[data-filter-content]') !== content){
                filter.querySelector('[data-filter-content]').classList.add('hidden');
                filter.classList.remove('active');
              }
              
            })
          })

          trigger.addEventListener('click', (e)=>{
            e.stopPropagation();
            if(content.classList.contains('hidden')){
              content.classList.remove('hidden')
              filter.classList.add('active')
            } else {
              content.classList.add('hidden')
              filter.classList.remove('active')
            }
          })

          for(let i = 0; i < items.length; i++){
            items[i].addEventListener('click', ()=>{

              let text;
              if (items[i].dataset.cleanText !== undefined) {
                text = items[i].querySelector('.text-to-copy').textContent;
                console.log(text)
              } else {
                text = items[i].innerHTML;
              }

                trigger.querySelector('[data-filter-inner]').innerHTML = text;
                if(!trigger.classList.contains('filled')) {
                  trigger.classList.add('filled');
                }
              })
          }

          window.addEventListener('click', ()=>{
            if(!content.classList.contains('hidden')){
              content.classList.add('hidden')
            }
            filter.classList.remove('active')
          })
        })
      }
    }
  },
  btnTrash: {
    init(){
      this.findInitFilterValue();
      this.btnAction();
    },
    initFilterValues: [],
    findInitFilterValue(){
        const filterWrappers = document.querySelectorAll('[data-filter-wrapper]');
        if(filterWrappers.length){
            filterWrappers.forEach((wrapper, index) => {
                const filterItems = wrapper.querySelectorAll('[data-filter-heading]');
                if(filterItems.length){
                    this.initFilterValues.push([])
                    filterItems.forEach(filter => this.initFilterValues[index].push(filter.innerText))
                }
            })
        }
    },
    btnAction(){
        const filterWrappers = document.querySelectorAll('[data-filter-wrapper]');
        filterWrappers.forEach((wrapper, wrapperIndex) => {
          const btnTrash = wrapper.querySelector('[data-filter-btn-trash]');
          
          const filters = wrapper.querySelectorAll('[data-filter-content]');
          let items = []
          filters.forEach(filter => {
            for(let i = 0; i < filter.children.length; i++){
              items.push(filter.children[i])
            }
          });
          items.forEach(filterItem => filterItem.addEventListener('click', ()=>{
            if(!btnTrash.classList.contains('filter-btn-trash-visible')){
              btnTrash.classList.add('filter-btn-trash-visible')
            }
          }))
          if(btnTrash){
              btnTrash.addEventListener('click', ()=>{
                  wrapper.querySelectorAll('[data-filter-heading]').forEach((filter, index) => {
                      filter.innerText = this.initFilterValues[wrapperIndex][index]
                      btnTrash.classList.remove('filter-btn-trash-visible');
                      console.log(filter);
                      filter.parentNode.classList.remove('filled');
                  })
              })
          }
      })
    }
  },
  modalWindow(){
    const containers = document.querySelectorAll('[data-modal-window-container]');
    if(containers.length){
      containers.forEach(container => {
        const trigger = container.querySelector('[data-trigger-open-modal]');
        const modalWindow = container.querySelector('[data-modal-window]');
        const btnClose = container.querySelector('[data-modal-close]');
        const btnDone = container.querySelector('[data-btn-done]');

        trigger.addEventListener('click', ()=>{
          if(modalWindow.classList.contains('hide')){
            modalWindow.classList.remove('hide')
          }
        })

        btnClose.addEventListener('click', ()=>{
          if(!modalWindow.classList.contains('hide')){
            modalWindow.classList.add('hide')
          }
        })

        btnDone?.addEventListener('click', ()=>{
          if(!modalWindow.classList.contains('hide')){
            modalWindow.classList.add('hide')
          }
        })

        window.addEventListener('resize', ()=>{
          if(window.innerWidth > 575.98){
            modalWindow.classList.add('hide');
          }
        })

      })
    }
  }
}

articles.init();
